// CircleProgressBar.jsx
// Refs: https://github.com/zzarcon/react-circle/blob/master/src/circle.tsx

import React from 'react';
import PropTypes from 'prop-types';
import { color } from '../style/variables.js';

const getCircleProgressOffset = (value, r) => {
  const diameter = Math.PI * 2 * r;
  return (1 - value / 100) * diameter;
};

const CircleProgressBar = ({
  value = 0,
  transition = 'stroke-dashoffset 0.2s ease-out',
  barColor = color.white,
  barStrokeWidth = 1,
  backgroundColor = 'rgba(255,255,255,0.3)',
  backgroundStrokeWidth = 1,
  size = 30,
}) => {
  const r = (size - Math.max(barStrokeWidth, backgroundStrokeWidth)) / 2;
  const strokeDashoffset = getCircleProgressOffset(value, r);
  const strokeDasharray = Math.PI * 2 * r;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <circle
        stroke={backgroundColor}
        cx={size / 2}
        cy={size / 2}
        r={r}
        strokeWidth={backgroundStrokeWidth}
        fill="none"
      />
      <circle
        stroke={barColor}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        cx={size / 2}
        cy={size / 2}
        r={r}
        strokeDasharray={strokeDasharray}
        strokeWidth={barStrokeWidth}
        strokeDashoffset={strokeDashoffset}
        strokeLinecap="round"
        fill="none"
        style={{
          transition,
        }}
      />
    </svg>
  );
};

CircleProgressBar.propTypes = {
  value: PropTypes.number,
  size: PropTypes.number,
  barColor: PropTypes.string,
  barStrokeWidth: PropTypes.number,
  backgroundColor: PropTypes.string,
  backgroundStrokeWidth: PropTypes.number,
  transition: PropTypes.string,
};

export default CircleProgressBar;
